import React from 'react'
import Link from 'gatsby-link'

const ServicesMenu = ({ lang }) => {
	if (lang === 'es') {
		return (
			<ul className="dropdown locations_menu_fleet">	
				<li>
					<Link to="/es/products-services">Productos y Servicios</Link>
				</li>
				<li>
					<Link to="/es/protections-coverages"> Protecciones y Coberturas </Link>
				</li>
			
				
			</ul>
		)
	}
	return (
		<ul className="dropdown locations_menu_fleet">
				<li>
					<Link to="/en/products-services">Products & Services</Link>
				</li>
				<li>
					<Link to="/en/protections-coverages"> Protections & Coverages </Link>
				</li>
			
			
		</ul>
	)
}

export default ServicesMenu



// WEBPACK FOOTER //
// ./src/menus/ServicesMenu.js